import { Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { OverlayHelper } from '../../Business/player/ui/OverlayHelper';

const Constants = {
  h: 140,
  Title: {
    Left: 50,
    Top: 15,
  },
  SubTitle: {
    Left: 50,
    Top: 65,
  },
  Clock: {
    Left: 1800,
    Top: 40,
  },
};
export class TitleBar extends lng.Component {
  static _template() {
    return {
      y: 0,
      h: Constants.h,
      w: w => w,
      Background: {
        y: 0,
        h: Constants.h,
        w: w => w,
        rect: true,
        colorTop: 0xb3000000,
        colorBottom: 0x00000000,
      },
      Title: {
        x: Constants.Title.Left,
        y: Constants.Title.Top,
        text: {
          ...Theme.Fonts.Player.TitleBar.Title,
          text: '',
        },
      },
      Subtitle: {
        x: Constants.SubTitle.Left,
        y: Constants.SubTitle.Top,
        flex: { direction: 'row' },
        Channel: {
          text: {
            ...Theme.Fonts.Player.TitleBar.Channel,
            text: '',
          },
        },
        Separator: {
          text: {
            ...Theme.Fonts.Player.TitleBar.Separator,
            text: ' • ',
          },
        },
        MetaInfo: {
          text: {
            ...Theme.Fonts.Player.TitleBar.MetaInfo,
            text: '',
          },
        },
      },
      Clock: {
        x: Constants.Clock.Left,
        y: Constants.Clock.Top,
        text: {
          ...Theme.Fonts.Player.TitleBar.Clock,
          text: '',
        },
      },
    };
  }

  _enable() {
    this.tag('Clock').text.text = OverlayHelper.getClock();
  }

  /**
   * @param {StreamInfo} info
   */
  setPlayInfo(info) {
    this.tag('Title').text.text = info.titleText;
    const channelText = this.tag('Channel').text;
    const MetaInfoText = this.tag('MetaInfo').text;
    channelText.text = info.channelName;
    MetaInfoText.text = info.metaInfo;
    if (channelText.text && MetaInfoText.text) {
      this.tag('Separator').visible = true;
    } else {
      this.tag('Separator').visible = false;
    }
  }

  /**
   * @param {PlayerController} playerController
   */
  registerEventHandler(playerController) {
    playerController.uiEventHandlers.updateTitleBarHandler = info => {
      this.setPlayInfo(info);
    };
  }
}
